import { render, staticRenderFns } from "./ActivitySpinner.vue?vue&type=template&id=64e5c5b9&"
import script from "./ActivitySpinner.vue?vue&type=script&lang=ts&"
export * from "./ActivitySpinner.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitySpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports